/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { PanelSkeleton } from '@atlassian/panel-system/panel-skeleton';

// This width is only set so the panel renders at a sensible size in the docs.
// Please use the navigation-system panel slot to size panels — do not hardcode this.
// In a real panel, the default skeleton is provided automatically by `PanelRouter`.
const styles = cssMap({
	exampleWrapper: {
		width: '400px',
		height: '480px',
	},
});

export function LoadingDefault(): JSX.Element {
	return (
		<Box xcss={styles.exampleWrapper}>
			<PanelSkeleton />
		</Box>
	);
}

export default LoadingDefault;
